/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'log-in',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/task',
      name: 'task-list',
      component: () => import('./views/Task.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./views/Setting.vue')
    },
    {
      path: '/offer',
      name: 'offer-list',
      component: () => import('./views/Offer.vue')
    },
    {
      path: '/offer/new',
      name: 'create-offer',
      component: () => import('./views/CreateOffer.vue')
    },
    {
      path: '/offer/:id',
      name: 'offer-info',
      component: () => import('./views/OfferView.vue')
    },
    {
      path: '/offer/edit/:id',
      name: 'edit-offer',
      component: () => import('./views/CreateOffer.vue')
    },
    {
      path: '/payment',
      name: 'payment-list',
      component: () => import('./views/Payment.vue')
    },
    {
      path: '/invoice/edit/:id',
      name: 'edit-invoice',
      component: () => import('./views/Invoice.vue')
    },
    {
      path: '/invoice_management',
      name: 'invoice_management',
      component: () => import('./views/InvoiceManagement.vue')
    },
    {
      path: '/client',
      name: 'client-list',
      component: () => import('./views/Client.vue')
    },
    {
      path: '/client/new',
      name: 'client-new',
      component: () => import('./views/CreateClient.vue')
    },
    {
      path: '/client/:id',
      name: 'client-info',
      component: () => import('./views/ClientView.vue')
    },
    {
      path: '/client/edit/:id',
      name: 'client-edit',
      component: () => import('./views/CreateClient.vue')
    },
    {
      path: '/contract_list',
      name: 'contract-list',
      component: () => import('./views/ContractList.vue')
    },
    {
      path: '/contract/new',
      name: 'create-contract',
      component: () => import('./views/Contract.vue')
    },
    {
      path: '/contract/:id',
      name: 'view-contract',
      component: () => import('./views/ContractView.vue')
    },
    {
      path: '/my_profile',
      name: 'my-profile',
      component: () => import('./views/MyProfile.vue')
    },
    {
      path: '/onboarding',
      name: 'onboarding-list',
      component: () => import('./views/Onboarding.vue')
    },
    {
      path: '/onboarding/new',
      name: 'new-onboarding',
      component: () => import('./views/CreateOnboarding.vue')
    },
    {
      path: '/onboarding/edit/:id',
      name: 'edit-onboard',
      component: () => import('./views/CreateOnboarding.vue')
    },
    {
      path: '/leaver_list',
      name: 'leaver-list',
      component: () => import('./views/Leaver.vue')
    },
    {
      path: '/staff_list',
      name: 'staff-list',
      component: () => import('./views/Staff.vue')
    },
    {
      path: '/profile/:id',
      name: 'view-profile',
      component: () => import('./views/Profile.vue')
    },
    {
      path: '/contract/edit/:id',
      name: 'edit-contract',
      component: () => import('./views/Contract.vue')
    },
    {
      path: '/revenue_report',
      name: 'revenue-report',
      component: () => import('./views/RevenueReport.vue')
    },
    {
      path: '/cashin_report',
      name: 'cashin-report',
      component: () => import('./views/Cashin.vue')
    },
    {
      path: '/ar_report',
      name: 'ar-report',
      component: () => import('./views/AR.vue')
    },
    {
      path: '/my_report',
      name: 'my-report',
      component: () => import('./views/Report.vue')
    },
    {
      path: '/bonus_check',
      name: 'bonus-check',
      component: () => import('./views/BonusCheck.vue')
    },
    {
      path: '/salary_list',
      name: 'salary-list',
      component: () => import('./views/Salary.vue')
    },
    {
      path: '/my_target_list',
      name: 'my-target-list',
      component: () => import('./views/ClientTarget.vue')
    },
    {
      path: '/namecard',
      name: 'namecard',
      component: () => import('./views/NameCard.vue')
    },
    {
      path: '/namecard/:id',
      name: 'namecard-view',
      component: () => import('./views/NameCard.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('./views/Events.vue')
    },
    {
      path: '/common_report/:source',
      name: 'common_report',
      component: () => import('./views/CommonReport.vue'),
      meta: { allowBack: false },
      children: [
        {
          path: ':uid',
          component: () => import('./views/CommonReport.vue')
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: () => import('./views/404.vue')
    },

  ],
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0}
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})